const types = {
  // GET ALL OBLP LISTING
  GET_OBLP_LISTING: "GET_OBLP_LISTING",
  GET_OBLP_LISTING_RESP: "GET_OBLP_LISTING_RESP",
  GET_OBLP_LISTING_CLEAR: "GET_OBLP_LISTING_CLEAR",

  // GET ALL NON-OBLP LISTING
  GET_NON_OBLP_LISTING: "GET_NON_OBLP_LISTING",
  GET_NON_OBLP_LISTING_RESP: "GET_NON_OBLP_LISTING_RESP",
  GET_NON_OBLP_LISTING_CLEAR: "GET_NON_OBLP_LISTING_CLEAR",

  // GET MY OBLP LISTING
  GET_MY_OBLP_LISTING: "GET_MY_OBLP_LISTING",
  GET_MY_OBLP_LISTING_RESP: "GET_MY_OBLP_LISTING_RESP",
  GET_MY_OBLP_LISTING_CLEAR: "GET_MY_OBLP_LISTING_CLEAR",

  // GET MY NON-OBLP LISTING
  GET_NON_MY_OBLP_LISTING: "GET_NON_MY_OBLP_LISTING",
  GET_NON_MY_OBLP_LISTING_RESP: "GET_NON_MY_OBLP_LISTING_RESP",
  GET_NON_MY_OBLP_LISTING_CLEAR: "GET_NON_MY_OBLP_LISTING_CLEAR",

  //Global Search LP
  GLOBAL_SEARCH_LP: " GLOBAL_SEARCH_LP",
  GLOBAL_SEARCH_LP_RESPONSE: " GLOBAL_SEARCH_LP_RESPONSE",
  GLOBAL_SEARCH_LP_CLEAR: " GLOBAL_SEARCH_LP_CLEAR",
  //Global Search Courses
  GLOBAL_SEARCH_COURSE: " GLOBAL_SEARCH_COURSE",
  GLOBAL_SEARCH_COURSE_RESPONSE: " GLOBAL_SEARCH_COURSE_RESPONSE",
  GLOBAL_SEARCH_COURSE_CLEAR: " GLOBAL_SEARCH_COURSE_CLEAR",

  //LP Included with subscription
  LP_INCLUDED_WITH_SUBSCRIPTION: "LP_INCLUDED_WITH_SUBSCRIPTION",
  LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE:
    "LP_INCLUDED_WITH_SUBSCRIPTION_RESPONSE",
  LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR: "LP_INCLUDED_WITH_SUBSCRIPTION_CLEAR",
};

export default types;
